import {createSlice} from '@reduxjs/toolkit';

const initialThemeColour = localStorage.getItem('themeColour') || '#ffffff';
const darkMode = localStorage.getItem('darkMode') || false;

const themeSlice = createSlice({
    name: 'theme',
    initialState:{
        themeColour: initialThemeColour,
        isDarkMode: darkMode
    },
    reducers:{
        setThemeColour: (state,action)=>{
            state.themeColour = action.payload;
            localStorage.setItem('themeColour',action.payload)
        },
        setDarkMode: (state,action)=>{
           state.isDarkMode = action.payload;
           localStorage.setItem('darkMode',state.isDarkMode);
           document.body.classList.toggle('dark-mode',state.isDarkMode);
        }
    }
})

export const {setThemeColour,setDarkMode} = themeSlice.actions;
export default themeSlice.reducer